export { default } from './FavoritesIndicator';
